import { t } from '@lingui/macro';
import React from 'react';
import { OverlayProps, TaskOverlay } from '.';

interface IntermediateStepTaskOverlayProps extends OverlayProps {
  title: string;
  submitButtonTitle?: string;
  onBack?(): void;
  onCompleteTask?(): void;
  isDisabled?: boolean;
  isLoading?: boolean;
}

export const IntermediateStepTaskOverlay: React.FC<
  IntermediateStepTaskOverlayProps
> = ({
  children,
  submitButtonTitle,
  isDisabled,
  isLoading,
  onBack,
  onCompleteTask,
  ...overlayProps
}) => {
  return (
    <TaskOverlay
      leftButton={{
        variant: 'Back',
        onClick: onBack || overlayProps.onClose,
      }}
      rightButton={
        onCompleteTask && {
          title: submitButtonTitle || t`Done`,
          onClick: onCompleteTask,
          isDisabled,
          isLoading,
        }
      }
      {...overlayProps}
    >
      {children}
    </TaskOverlay>
  );
};
